export default __webpack_public_path__ + "static/media/laval16.2e611ea5.jpg";